var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { defaultProps } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
import Select from '../Select';
import Radio from '../Radio';
var Group = Radio.Group;
var Option = Select.Option;
var YearSelectOffset = 10;
var YearSelectTotal = 20;
var YearSelect = function (props) {
    var year = props.year, fullscreen = props.fullscreen, month = props.month, _a = props.onChange, onChange = _a === void 0 ? function () { } : _a;
    var start = year - YearSelectOffset;
    var end = start + YearSelectTotal;
    var suffix = '年';
    var options = [];
    for (var index = start; index < end; index++) {
        options.push({ value: "" + index + suffix });
    }
    var optionsHtml = options.map(function (o) { return React.createElement(Option, { value: o.value }, o.value); });
    return (React.createElement(Select, { size: fullscreen ? undefined : 'small', clear: false, value: "" + year + suffix, className: "year-select", onChange: function (value) {
            onChange(value.replace(suffix, ''), month);
        } }, optionsHtml));
};
var MonthSelect = function (props) {
    var month = props.month, year = props.year, fullscreen = props.fullscreen, _a = props.onChange, onChange = _a === void 0 ? function () { } : _a;
    var start = 1;
    var end = 13;
    var suffix = '月';
    var options = [];
    for (var index = start; index < end; index++) {
        options.push({ value: "" + index + suffix });
    }
    var optionsHtml = options.map(function (o) { return React.createElement(Option, { value: o.value }, o.value); });
    return (React.createElement(Select, { size: fullscreen ? undefined : 'small', clear: false, value: "" + month + suffix, className: "month-select", onChange: function (value) {
            onChange(year, value.replace(suffix, ''));
        } }, optionsHtml));
};
var ModeSwitch = function (props) {
    var mode = props.mode, onModeChange = props.onModeChange;
    return (React.createElement(Group, { onChange: function (value) {
            onModeChange(value);
        }, value: mode, className: "inline-block align-top legao-radio-group", name: "" },
        React.createElement(Radio, { name: "radioButton", className: "legao-radio-button radio-button", value: "month" }, "\u6708"),
        React.createElement(Radio, { name: "radioButton", className: "legao-radio-button radio-button", value: "year" }, "\u5E74")));
};
var DateHeader = /** @class */ (function (_super) {
    __extends(DateHeader, _super);
    function DateHeader(props) {
        var _this = _super.call(this, props) || this;
        var year = _this.props.year;
        _this.state = {
            currYear: year,
        };
        return _this;
    }
    DateHeader.prototype.render = function () {
        var _a = this.props, mode = _a.mode, onModeChange = _a.onModeChange;
        return (React.createElement(DivTag, { atomics: ['flex'], className: "date-header", name: DateHeader.NAME },
            React.createElement(YearSelect, __assign({}, this.props)),
            mode === 'month' && React.createElement(MonthSelect, __assign({}, this.props)),
            React.createElement(ModeSwitch, { onModeChange: onModeChange, mode: mode })));
    };
    DateHeader.defaultProps = defaultProps;
    DateHeader.NAME = 'date-header';
    return DateHeader;
}(Component));
export { DateHeader };
